// 外观模块
export default {
    Appearance: {
        MobilePhone: 'Telephone Bimbit',
        Computer: 'Komputer',
        AppearanceSettings: 'Tetapan Panampilan',
        Header: 'Pengepala',
        ShowHeader: 'Paparkan Pengepala',
        HeaderType: 'Jenis Pengepala',
        Writing: 'Penulisan',
        Single: 'Tunggal',
        TextContent: 'Kandungan Teks',
        PleaseEnterContent: 'Sila Masukan Kandungan',
        FontSettings: 'Tetapan Fon',
        Align: 'Imbang',
        LeftJustifying: 'Jajarkan Kiri',
        Center: 'Tengah',
        RightAlignment: 'Jajarkan Kanan',
        bgColor: 'Warna Latar',
        HeaderImage: 'Gambar Pengepala',
        AddPicture: 'Sisip Gambar',
        Background: 'Later',
        BackgroundSettings: 'Format Latar',
        Pictures: 'Gamabar',
        ChooseAColor: 'Pilih Warna',
        BackgroundImage: 'Gambar Latar',
        BackgroundPosition: 'Posisi Latar',
        Tile: 'Susun Atur',
        BackgroundTransparency: 'Kelutsinaran Latar',
        LogoSettings: 'Tetapan Logo',
        LogoLocation: 'Posisi Logo',
        ProjectTitle: 'Tajuk Projek',
        WelcomeMessage: 'Mesej Alu-Aluan',
        Stem: 'Kenyataan Soalan',
        Option: 'Opsyen',
        Conclusion: 'Kesimpulan',
        ButtonSettings: 'Tetapan Butang',
        SubmitButtonText: 'Hantar Teks Butang',
        DisplaySettings: 'Tetapan Paparan',
        ShowHeading: 'Paparkan Pengepala',
        ShowWelcomeMessage: 'Paparkan Mesej Alu-Aluan',
        DisplayQuestionNumber: 'Paparkan Nombor Soalan',
        SubmitTo: 'Hantar Ke'
    },
  };